// extracted by LIB_CSS_EXTRACT_LOADER
import "./checkbox-group_module.css"
export default {"group":"group-P3ekXA"};